import type { PersonRelation } from '../types'

// Interaction stories for relations declared in the earlier data files, keyed by `fromId>targetId`.
export const bondStories: Record<string, string> = {
  'confucius>mencius': '孟子生于孔子去世约百年后，自称“乃所愿，则学孔子也”，两人并无直接交往。',
  'qin-shihuang>li-si': '李斯上《谏逐客书》劝阻秦王驱逐客卿，后任丞相，推行郡县制与“书同文”。',
  'han-wudi>zhang-qian': '前139年张骞奉武帝之命出使大月氏，途中被匈奴扣留十余年，前126年方归长安。',
  'cao-cao>cao-zhi': '曹操一度欲立曹植为嗣，后因其任性饮酒、擅开司马门而作罢。',
  'cao-cao>liu-bei': '刘备依附曹操时，曹操从容说“今天下英雄，唯使君与操耳”，刘备惊得失落匕箸。',
  'liu-bei>zhuge-liang': '207年刘备三顾茅庐，诸葛亮在隆中提出三分天下之策；223年刘备在白帝城托孤。',
  'liu-bei>guan-yu': '《三国志》称刘备与关羽、张飞“寝则同床，恩若兄弟”；“桃园结义”则出自后世小说。',
  'li-bai>du-fu': '744年李白被赐金放还，与杜甫在洛阳相遇，同游梁宋、齐鲁；此后杜甫写下十余首怀念李白的诗。',
  'su-shi>huang-tingjian': '黄庭坚早年寄诗求教，苏轼称其诗文“超逸绝尘”，二人亦师亦友，后世并称“苏黄”。',
  'wang-anshi>sima-guang': '二人早年同僚、私交甚笃；熙宁变法中司马光三次致书劝阻，王安石作《答司马谏议书》逐条回应。',
  'lin-zexu>wei-yuan': '1841年林则徐被贬途经镇江，将《四洲志》等资料托付魏源，魏源据此编成《海国图志》。',
  'xunzi>han-fei': '韩非与李斯同学于荀子门下，《史记》说李斯自认才能不如韩非。',
  'han-fei>li-si': '韩非出使秦国后，李斯与姚贾进谗，前233年韩非在狱中被迫服毒。',
  'xiang-yu>liu-bang': '前206年鸿门宴上项羽放走刘邦；前202年垓下之战项羽兵败，在乌江自刎。',
  'fan-zeng>xiang-yu': '鸿门宴上范增三次举起玉玦示意项羽杀刘邦，项羽不应；后项羽中陈平反间，范增愤而辞归。',
  'xiao-he>han-xin': '韩信不得重用而逃亡，萧何连夜追回并力荐为大将，留下“萧何月下追韩信”的故事。',
  'zhang-liang>liu-bang': '刘邦称张良“运筹帷幄之中，决胜千里之外”，鸿门宴上正是张良安排刘邦脱身。',
  'zhou-yu>sun-quan': '208年周瑜力主抗曹，与程普率吴军联合刘备，在赤壁以火攻大破曹军。',
  'sima-yi>zhuge-liang': '234年五丈原对峙，司马懿坚守不战；诸葛亮送去妇人巾帼相激，他仍不出战。',
  'cai-wenji>cao-cao': '曹操念及与蔡邕旧交，以金璧从南匈奴赎回蔡文姬，她凭记忆默写出四百余篇亡佚典籍。',
  'lu-xun>liu-bei': '222年夷陵之战，陆逊火烧连营大败刘备，刘备退至白帝城，次年病逝。',
  'lu-bu>cao-cao': '198年曹操水淹下邳擒获吕布，刘备提醒丁原、董卓旧事，曹操遂下令缢杀吕布。',
  'ji-kang>ruan-ji': '阮籍能作青白眼，嵇喜来吊以白眼相对，嵇康携酒挟琴而来，阮籍则青眼相迎。',
  'wang-xianzhi>wang-xizhi': '相传王献之幼年学书，王羲之从背后抽其笔而不脱，叹“此儿后当复有大名”。',
  'wei-zheng>tang-taizong': '魏徵前后进谏二百余事，643年去世，太宗叹“以人为镜，可以明得失……遂亡一镜矣”。',
  'di-renjie>wu-zetian': '武则天称狄仁杰为“国老”而不呼其名，他先后举荐张柬之、姚崇等数十位名臣。',
  'wang-wei>li-bai': '王维与李白同年出生、同时活跃于长安，却没有任何诗文往来的记录，是文学史上的著名谜题。',
  'liu-zongyuan>han-yu': '二人同倡古文运动、并称“韩柳”；柳宗元去世后，韩愈为他撰写墓志铭与《柳州罗池庙碑》。',
  'li-keyong>zhu-wen': '884年上源驿之变，朱温夜袭宴后醉卧的李克用，两家从此结下世仇。',
  'ouyang-xiu>su-shi': '1057年欧阳修主持礼部考试，读苏轼文章后说“老夫当避路，放他出一头地”。',
  'zhou-dunyi>zhu-xi': '朱熹为周敦颐的《太极图说》《通书》作注解，将其推为理学开山。',
  'mi-fu>su-shi': '1082年米芾拜访贬居中的苏轼，苏轼劝他学习晋人书法，米芾书风由此转向。',
  'liu-bingzhong>kublai-khan': '刘秉忠为忽必烈规划上都与大都城址，并建议取《易经》“大哉乾元”定国号为元。',
  'tang-yin>wen-zhengming': '二人同年出生、同在吴门求学；唐寅科场案后放浪不羁，文徵明写信规劝，友情一度起伏。',
  'li-hongzhang>zeng-guofan': '1859年李鸿章入曾国藩幕府，1862年奉命回合肥招募淮军，乘轮船驰援上海。',
  'kang-youwei>liang-qichao': '1890年梁启超拜入康有为门下，在广州万木草堂求学；1895年二人发动在京举人公车上书。',
  'duke-huan-qi>guan-zhong': '管仲曾射中公子小白的带钩，小白即位为齐桓公后听从鲍叔牙举荐，不计前仇拜其为相。',
  'fusu>meng-tian': '扶苏因劝谏被派往上郡监蒙恬军；沙丘之变后二人接到伪诏，扶苏自杀、蒙恬被囚。',
  'empress-lu>liu-bang': '吕雉在楚汉战争中一度被项羽俘为人质；刘邦去世后她临朝称制八年。',
  'ban-chao>ban-gu': '班固私修国史被人告发下狱，班超赶赴洛阳上书申辩，班固获释并受任兰台令史。',
  'ban-chao>ban-zhao': '班超年老思归，班昭上书汉和帝代兄陈情，班超终于102年回到洛阳。',
  'cao-pi>cao-zhi': '《世说新语》载曹丕令曹植七步成诗，曹植作“本是同根生，相煎何太急”，此事不见于正史。',
  'zhao-yun>liu-bei': '长坂之战刘备弃妻子南逃，赵云怀抱幼主刘禅，保护甘夫人脱险。',
  'xun-yu>cao-cao': '曹操称荀彧为“吾之子房”；后荀彧反对曹操进爵魏公，在寿春忧郁而死。',
  'xun-yu>guo-jia': '荀彧向曹操推荐郭嘉，曹操与之论天下事后说“使孤成大业者，必此人也”。',
  'wei-shuo>wang-xizhi': '传统认为王羲之少年从卫夫人学书，卫夫人所撰《笔阵图》相传即为授书之作。',
  'du-yu>sima-yan': '279年杜预与王濬等分路伐吴，次年孙皓出降，西晋统一全国。',
  'hou-jing>liang-wudi': '548年侯景起兵渡江围攻台城，次年城破，梁武帝被困饿死于净居殿。',
  'han-qinhu>sui-wendi': '589年韩擒虎率五百人夜渡长江，直入建康朱雀门，俘获陈后主。',
  'gao-jiong>sui-wendi': '高颎辅佐杨坚代周建隋，主持制定开皇律令并规划灭陈，执政近二十年。',
  'dugu-qieluo>sui-wendi': '杨坚与独孤伽罗成婚时立誓“无异生之子”，宫中将二人并称“二圣”。',
  'tang-xuanzong>yang-guifei': '756年马嵬驿兵变，六军不发，玄宗被迫赐杨贵妃自缢。',
  'zhang-jiuling>tang-xuanzong': '张九龄罢相后，玄宗每逢有人推荐人才，仍要问一句“风度得如九龄否”。',
  'liu-gongquan>yan-zhenqing': '柳公权楷书初学王羲之，后遍观颜真卿等唐代名家，世称“颜筋柳骨”。',
  'shi-jingtang>yelu-abaoji': '936年石敬瑭割让燕云十六州，向阿保机之子耶律德光称“儿皇帝”以换取出兵。',
  'guo-wei>chai-rong': '柴荣是郭威皇后柴氏的侄子，被郭威收为养子，954年继位为后周世宗。',
  'cheng-hao>cheng-yi': '二程少年同受学于周敦颐，后在洛阳讲学；“程门立雪”说的正是杨时拜见程颐。',
  'han-derang>empress-xiao': '萧太后摄政期间韩德让总理朝政、掌管宿卫，辽圣宗待之如父。',
  'wanyan-zongbi>yue-fei': '1140年郾城之战岳家军大破金兀术的拐子马，金军中流传“撼山易，撼岳家军难”。',
  'genghis-khan>kublai-khan': '据《史集》，1224年成吉思汗西征归来，十一岁的忽必烈在途中迎接并初次行猎。',
  'chen-youliang>zhu-yuanzhang': '1363年鄱阳湖之战，朱元璋以火攻大破陈友谅水军，陈友谅中流矢而死。',
  'yongle-emperor>zheng-he': '1405年明成祖派郑和率二万七千余人首次下西洋，此后二十八年间共七次远航。',
  'xie-jin>yongle-emperor': '解缙奉命主持编纂《永乐大典》，后因议立太子得罪朱棣，死于狱中。',
  'ji-yun>qianlong': '1773年乾隆帝开四库全书馆，纪昀任总纂官十余年，主持撰成《四库全书总目》。',
  'hong-xiuquan>zeng-guofan': '1864年湘军攻破天京，洪秀全已于城破前一个多月病逝。',
  'tan-sitong>liang-qichao': '戊戌政变后谭嗣同拒绝出走，对梁启超说“各国变法，无不从流血而成……请自嗣同始”。',
  'qiu-jin>sun-yat-sen': '1905年秋瑾在东京加入同盟会，被推为浙江主盟人。',
}

export interface ExtraBond extends PersonRelation {
  fromId: string
}

// Documented ties between people who were already on the map but not yet linked.
export const extraBonds: ExtraBond[] = [
  { fromId: 'du-fu', targetId: 'zhuge-liang', kind: 'influence', label: '《蜀相》', story: '760年杜甫到成都武侯祠作《蜀相》：“出师未捷身先死，长使英雄泪满襟。”' },
  { fromId: 'su-shi', targetId: 'tao-yuanming', kind: 'influence', label: '遍和陶诗', story: '苏轼晚年遍和陶渊明诗一百余首，自称“吾于诗人无所甚好，独好渊明之诗”。' },
  { fromId: 'xuanzang', targetId: 'faxian', kind: 'influence', label: '西行求法先驱', story: '法显比玄奘早两百余年西行天竺，其《佛国记》是玄奘之前最重要的求法行记。' },
  { fromId: 'hua-tuo', targetId: 'cao-cao', kind: 'historical', label: '侍医与被杀', story: '华佗为曹操针治头风，后托辞妻病久不归，被曹操收押处死，曹操晚年痛悔。' },
  { fromId: 'song-taizu', targetId: 'chai-rong', kind: 'historical', label: '后周旧将', story: '赵匡胤受柴荣重用任殿前都点检；960年陈桥兵变，他从柴荣幼子手中取得政权。' },
  { fromId: 'zheng-banqiao', targetId: 'xu-wei', kind: 'influence', label: '青藤门下牛马走', story: '郑板桥极推崇徐渭，刻有一方“青藤门下牛马走”印章。' },
  { fromId: 'xin-qiji', targetId: 'zhu-xi', kind: 'friend', label: '往哭朱子', story: '1200年朱熹在党禁中去世，辛弃疾不顾禁令作文往哭：“孰谓公死，凛凛犹生。”' },
  { fromId: 'xin-qiji', targetId: 'lu-you', kind: 'friend', label: '绍兴相访', story: '1203年辛弃疾知绍兴府，拜访年近八旬的陆游，欲为其修屋；次年陆游作长诗送他赴任。' },
  { fromId: 'wang-yangming', targetId: 'zhu-xi', kind: 'influence', label: '格竹与龙场悟道', story: '王阳明青年时依朱熹“格物”之说对竹苦思七日而病，后在龙场悟出“心即理”。' },
  { fromId: 'bai-juyi', targetId: 'du-fu', kind: 'influence', label: '推崇杜诗', story: '白居易《与元九书》特别推崇杜甫《新安吏》《石壕吏》等作品，新乐府即承此传统。' },
  { fromId: 'sima-qian', targetId: 'confucius', kind: 'influence', label: '《孔子世家》', story: '司马迁为孔子立“世家”，赞曰“高山仰止，景行行止，虽不能至，然心乡往之”。' },
  { fromId: 'sima-qian', targetId: 'han-wudi', kind: 'historical', label: '李陵之祸', story: '前99年司马迁为李陵辩护触怒武帝，受宫刑后忍辱发愤，完成《史记》。' },
  { fromId: 'sima-qian', targetId: 'li-guang', kind: 'influence', label: '《李将军列传》', story: '司马迁写李广“桃李不言，下自成蹊”，并记其终身未得封侯的遗憾。' },
  { fromId: 'xie-an', targetId: 'wang-xizhi', kind: 'friend', label: '兰亭修禊', story: '353年三月初三，谢安与王羲之等四十余人在会稽山阴兰亭修禊，王羲之写下《兰亭集序》。' },
  { fromId: 'li-shangyin', targetId: 'du-mu', kind: 'peer', label: '小李杜', story: '李商隐作《杜司勋》：“刻意伤春复伤别，人间惟有杜司勋。”二人后并称“小李杜”。' },
  { fromId: 'lin-zexu', targetId: 'zuo-zongtang', kind: 'mentor', label: '湘江夜话', story: '1850年初林则徐在长沙湘江舟中与左宗棠彻夜长谈，把多年收集的新疆资料托付给他。' },
  { fromId: 'zuo-zongtang', targetId: 'zeng-guofan', kind: 'historical', label: '湘军同僚与失和', story: '左宗棠在曾国藩麾下起家，后二人失和；曾国藩去世时左宗棠挽联自称“谋国之忠，自愧不如”。' },
  { fromId: 'guo-shoujing', targetId: 'liu-bingzhong', kind: 'mentor', label: '紫金山求学', story: '郭守敬少年时在邢台紫金山随刘秉忠学习天文、算学与水利。' },
  { fromId: 'zhao-mengfu', targetId: 'kublai-khan', kind: 'historical', label: '江南访贤', story: '1286年程钜夫奉命江南访贤，赵孟頫入大都觐见，忽必烈称其为“神仙中人”。' },
  { fromId: 'qi-jiguang', targetId: 'zhang-juzheng', kind: 'historical', label: '镇守蓟州', story: '张居正调戚继光总理蓟州军务，他修筑空心敌台、镇守十六年，北边晏然。' },
  { fromId: 'nalan-xingde', targetId: 'kangxi', kind: 'historical', label: '御前侍卫', story: '纳兰性德任康熙帝一等侍卫，多次随驾南巡北狩，边塞词多作于扈从途中。' },
]
